import { render, staticRenderFns } from "./AccountAddressBook.vue?vue&type=template&id=11f0e7cd&"
import script from "./AccountAddressBook.vue?vue&type=script&lang=js&"
export * from "./AccountAddressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports